<template>
    <Modal ref="modal" class="add-order-package-tracking-modal" @closed="onModalClose">
        <template #header>
            <div class="h3">Ajout d'un numéro de suivi</div>
        </template>
        <template #body="sp">
            <div class="form-group">
                <label for="trackingNumber">Numéro de suivi</label>
                <input class="form-control" type="text" id="trackingNumber" v-model="trackingNumber">
            </div>

            <div class="form-group">
                <label for="description">Description <small>(optionnel)</small></label>
                <textarea class="form-control" id="description" v-model="description"></textarea>
            </div>

            <div class="form-group">
                <label>Cocher les commandes expédiées dans le colis</label>


                <ul class="list-group">
                    <template v-for="(pickupPointSubcustomers, pickupPointName) in subcustomersByPickupPoint">
                        <li
                            v-if="subcustomersByPickupPoint.length > 1 || pickupPointName !== 'N/C'"
                            class="list-group-item list-group-item-info font-weight-bold"
                        >
                            {{ pickupPointName }}
                        </li>
                        <li
                            v-for="subcustomer in pickupPointSubcustomers"
                            :key="subcustomer.id"
                            class="list-group-item d-flex"
                        >
                            <div
                                class="text-nowrap"
                                v-if="!subcustomer.ref || subcustomer.ref.startsWith('(')"
                            >
                                n°<strong class="bg-light border border-danger px-1 ml-1 rounded text-danger">
                                    <i class="fad fa-exclamation-triangle"></i>
                                    <span>Inconnu</span>
                                </strong>
                            </div>
                            <div class="text-nowrap" v-else>
                                n°<strong class="bg-light border border-dark px-1 ml-1 rounded">{{ subcustomer.ref }}</strong>
                            </div>
                            <div class="list-group-item-subcustomer-name text-ellipsis">
                                {{ subcustomer.name }}
                            </div>
                            <div>
                                <input class="form-check-input" type="checkbox" v-model="refs" :value="subcustomer.ref">
                            </div>
                        </li>
                    </template>
                </ul>
            </div>
        </template>
        <template #footer>
            <ErrorsZone v-if="sendingErrors" :errors="sendingErrors"></ErrorsZone>

            <div class="d-flex justify-content-between w-100">
                <button class="btn btn-secondary" @click="closeModal()" :disabled="sending">
                    <i class="fad fa-arrow-left"></i> Fermer
                </button>

                <button class="btn btn-success" @click="submitForm()" :disabled="sending">
                    <i class="fad fa-plus"></i> Ajouter
                </button>
            </div>
        </template>
    </Modal>
</template>

<script>
import Modal from "../Modal";
import ErrorsZone from "../ErrorsZone";

import {usePostRequest} from "../compositions/axios/postRequest";

export default {
    name: 'AddOrderPackageTrackingModal',

    components: {
        Modal,
        ErrorsZone,
    },

    setup() {
        const {
            loading: sending,
            loaded: sent,
            errors: sendingErrors,
            post: send,
        } = usePostRequest();

        return {
            sending,
            sent,
            sendingErrors,
            send,
        };
    },

    props: {
        order: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            subcustomers: null,
            trackingNumber: '',
            description: '',
            refs: [],
        };
    },

    computed: {
        subcustomersByPickupPoint() {
            let subcustomersByPickupPoint = {};
            for (const subcustomer of this.order.subcustomers) {
                const pickupPoint = subcustomer.meta.pickup_point || 'N/C';
                if (!subcustomersByPickupPoint.hasOwnProperty(pickupPoint)) {
                    subcustomersByPickupPoint[pickupPoint] = [];
                }

                const orderedProduct = this.order.ordered_products.find((op) => op.pivot.fk_subcustomer === subcustomer.id);

                subcustomersByPickupPoint[pickupPoint].push({
                    ...subcustomer,
                    ref: (orderedProduct && orderedProduct.pivot.ref) || 'INCONNU',
                });
            }
            return subcustomersByPickupPoint;
        },
    },

    methods: {
        showModal() {
            this.$refs.modal.showModal();
        },

        closeModal() {
            this.$refs.modal.closeModal();
        },

        onModalClose() {
            this.resetForm();
        },

        async submitForm() {
            const data = {
                tracking_number: this.trackingNumber,
                description: this.description,
                refs: this.refs,
            };
            const response = await this.send(`/espace-employes/commandes/${this.order.id}/suivi-colis`, data);
            if (response && response.success) {
                this.$emit('trackingNumberAdded', data);
                this.closeModal();
            }
        },

        resetForm() {
            this.trackingNumber = '';
            this.description = '';
            this.refs = [];

            this.sent = false;
            this.sendingErrors = null;
        },
    },
}
</script>

<style lang="scss">
.add-order-package-tracking-modal {
    :first-of-type(.modal-container) {
        max-width: 800px;
        width: auto;
    }

    .list-group-item-subcustomer-name {
        flex-grow: 1;
        margin-left: 9px;
    }
}
</style>
